import { render } from "./UnpaidBanner.vue?vue&type=template&id=56794ed6&scoped=true"
import script from "./UnpaidBanner.vue?vue&type=script&lang=js"
export * from "./UnpaidBanner.vue?vue&type=script&lang=js"

import "./UnpaidBanner.vue?vue&type=style&index=0&id=56794ed6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56794ed6"]])

export default __exports__